@import "../../styles/mixins/form-search-bar";

// note: on website there is nasty `.se-reset-css div` selector that overrides
// most of styles, so we need to increase the selector strength
// so we add `.add-selector-strength` class...

uiaas-guided-search-v2.add-selector-strength form,
.guided-v2__search-bar__form {
  @include from-search-bar;
  z-index: var(--z-index-form-search-bar, 2);
}

uiaas-guided-search-v2.add-selector-strength .search-bar__cancel,
.guided-v2__search-bar__cancel {
  z-index: var(--z-index-form-search-bar, 2);
}

.guided-v2__no-scroll {
  overflow: hidden;
}

:host.guided-v2-host__input-active {
  @media (max-width: 720px) {
    position: unset;
    padding: 0;
    top: 0;
  }
}

:host {
  display: block;
  width: auto; // Required to set proper width for guided-pane for mozilla
}

uiaas-guided-search-v2.add-selector-strength {
  div.guided_v2__backdrop {
    visibility: hidden;
    position: fixed;
    top: -100px;
    left: 0;
    width: 120vw;
    height: calc(100vh + 100px);
    background: white;
    z-index: var(--z-index-backdrop, 1);

    @media (min-width: 720px) {
      background: #333333;
      opacity: 0.7;
    }
    @media (max-width: 720px) {
      //position: absolute;
      background: var(--main-subsection-standard-background, #fcfcfc);
      top: 62px;
      left: -20px;
    }

    &.guided_v2__backdrop--visible {
      visibility: visible;
    }
  }

  div.guided_v2__backdrop-pane-visible {
    visibility: hidden;
    position: fixed;
    top: -100px;
    left: 0;
    width: 120vw;
    height: calc(100vh + 100px);
    background: #333333;
    opacity: 0.7;
    z-index: var(--z-index-backdrop, 1);

    @media (max-width: 720px) {
      top: 62px;
      left: -20px;
    }

    &.guided_v2__backdrop--visible {
      visibility: visible;
    }
  }

  div.guided-v2-backdrop-fix {
    position: relative;
    z-index: var(--svs-guided2-backdropfix-zindex, 25);
  }

  .guided-v2-wrapper {
    max-width: 920px;
  }

  div.guided-v2-pane.add-selector-strength {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    overflow-x: hidden;
    z-index: var(--z-index-guided-pane, 25);
    scroll-padding-top: 104px;
    max-width: 100%;

    margin-top: 8px;
    border-radius: 12px;
    background: var(--main-subsection-standard-background, #fcfcfc);

    @media (min-width: 721px) {
      overflow-y: auto;
      max-height: calc(100vh - 160px);
      top: var(--svs-guided2-pane-top-offset, calc(100%));
      border-radius: var(--qds-main-subsection-border-radius, 12px);
      box-shadow: 0 2px 5px rgb(98 100 105 / 50%);
      //box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
    }

    @media (max-width: 720px) {
      padding-top: 0;
      margin-top: 18px;
      width: initial;
      left: -12px;
      right: -12px;
      max-height: calc(100vh - 124px);
      max-width: calc(100% + 24px);
      border-radius: 0;

      &.pane-visible {
        left: 0px;
        right: 0px;
        max-width: 100%;
        border-radius: 12px;
      }
    }

    &.guided-pane--hidden-no-data,
    &.guided-pane--hidden-no-focus {
      display: none;
    }

    @import "../design-system/mega-banner/mega-banner";

    @import "./subcomponents/pna-quick-link/pna-quick-link";
  }

  div.guided-v2-pane--shadow.add-selector-strength
    > .filter-by-section.add-selector-strength {
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.25);
  }

  .guided-v2-section {
    @media (max-width: 720px) {
      overflow-y: auto;
      max-height: calc(100% - 200px);
    }

    &__content {
      padding-bottom: 16px;

      qds-divider {
        margin: 8px 16px;
        @media (max-width: 720px) {
          display: none;
        }
      }
    }
  }

  .guided-v2-result-list-section {
    &__section {
      span.highlight {
        font-weight: 700;
      }
    }

    &__section-title.add-selector-strength {
      padding: 8px 16px;
      background-color: var(--qds-theme-main-background, #f4f4f4);
    }

    &__links.add-selector-strength {
      padding: 0;
      margin: 0;
      padding-inline-start: 0;
    }

    &__result.add-selector-strength {
      list-style: none;
      margin: 0;

      &:hover .guided-v2-result-list-section__result-title {
        text-decoration: underline;
        text-decoration-color: #000000;
      }
    }

    &__result-link.add-selector-strength {
      padding: 12px 16px;
      color: #000000;
      text-decoration: none;
      display: block;

      &:hover {
        background-color: var(
          --qds-theme-interactive-background-hover,
          #e6e6e6
        );
      }

      &:active {
        background-color: var(
          --qds-theme-interactive-background-pressed,
          #cccccc
        );
      }
    }
    &__result-link.add-selector-strength.products,
    &__result-link.add-selector-strength.video-tutorials {
      display: flex;
      @media (max-width: 720px) {
        flex-direction: column;
      }
    }
    &__result-link.add-selector-strength.document-download {
      display: flex;
      justify-content: space-between;
    }

    &__result-title.add-selector-strength {
      font-family: var(--qds-font-family-brand, "Arial Rounded MT for SE");
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 20px;
      color: #000000;
      padding: 0;
      word-wrap: break-word;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    &__result-image.add-selector-strength {
      width: 80px;
      height: 80px;
      border-radius: var(--qds-control-border-radious, 4px);
      margin-right: 16px;
    }

    &__result-extra.add-selector-strength {
      font-family: var(--qds-font-family-brand, "Arial Rounded MT for SE");
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 20px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px;
      color: #626469;
      margin-top: 8px;
      @media (max-width: 720px) {
        max-width: calc(
          100vw - 140px
        ); // prevents qds-tags overflowing on mobile
      }
      & > .guided2__result-extra-info,
      & .svs-tag {
        margin: 0 !important;
      }
    }
    &__result-content {
      display: flex;
    }
    &__result-icon {
      align-self: center;
      margin: 8px 8px 8px 24px;
      height: 16px;
      width: 16px;
    }

    &__result-extra-info {
      &:not(:last-child):after {
        content: " | ";
      }
    }

    &__add-to-cart-button {
      display: flex;
      flex-grow: 1;
      flex-shrink: 0;
      align-items: center;
      justify-content: flex-end;
      margin-left: 16px;
      @media (max-width: 720px) {
        display: block;
        margin-top: 16px;
        width: 100%;
        margin-left: 0;
      }
    }
    &__product-link-container {
      display: flex;
    }
  }

  .guided-v2-skeleton {
    @keyframes skeletonMove {
      0% {
        background-position: -200px 0;
      }

      100% {
        background-position: calc(200px + 100%) 0;
      }
    }

    &__item {
      background-color: #e6e6e6;
      background-image: linear-gradient(
        90deg,
        rgb(230, 230, 230),
        rgb(247, 247, 247),
        rgb(230, 230, 230)
      );
      animation: skeletonMove 1.2s ease-in-out infinite;
      background-size: 200px 100%;
      background-repeat: no-repeat;
      border-radius: 2px;
      display: block;
      width: var(--skel-width, 100%);
      margin: 4px 0;
      height: var(--skel-height, 22px);

      &:nth-child(2) {
        width: calc(0.7 * var(--skel-width, 100%));
      }
    }
  }

  div.filter-by-section.add-selector-strength {
    //display: flex;
    //flex-direction: column;
    //align-items: flex-start;
    //padding-left: var(--list-item-large-padding-horizontal, 16px);
    //padding-right: var(--list-item-large-padding-horizontal, 16px);
    padding-bottom: var(--list-item-large-padding-horizontal, 16px);
    padding-top: var(--list-item-large-padding-horizontal, 16px);
    width: 100%;
    overflow-x: hidden;
    position: sticky;
    z-index: 10;
    top: 0;
    background: var(--main-subsection-standard-background, #fcfcfc);

    @media (max-width: 720px) {
      position: sticky;
      z-index: 10;
      top: 0;
      background: var(--main-subsection-standard-background, #fcfcfc);
    }
  }

  span.filter-by-section__label.add-selector-strength {
    font: var(--qds-control-small-text);
    color: var(--qds-theme-text-subdued);
    display: flex;
    padding: 0;

    align-items: center;
    gap: 10px;
    align-self: stretch;
  }

  uiaas-guided-v2-chips-carousel.add-selector-strength {
    display: block;
    margin: 16px 0;
  }

  .guided-v2-result-list-section__result-extra-info .highlight {
    font-weight: bold;
  }

  .guided-v2-result-list-section__result-extra-info.guided-v2-importance__emphasized {
    background: #0075a3;
    border-radius: 1em;
    padding: 0.3em 0.5em;
    color: white;

    &::after {
      visibility: hidden;
    }
  }

  div.guided-v2-keyword-suggestions.add-selector-strength {
    //display: flex;
    //flex-direction: column;
    //align-items: flex-start;
    //padding-left: var(--list-item-large-padding-horizontal, 16px);
    //padding-right: var(--list-item-large-padding-horizontal, 16px);

    max-width: 100%;
    //outline: 2px solid red;
    //overflow-x: auto;

    .suggestion-bar__label {
      font: var(--qds-control-small-text);
      color: var(--qds-theme-text-subdued);
      display: flex;
      padding: 0;
      align-items: center;
      gap: 10px;
      align-self: stretch;
    }

    .guided-v2-suggestions-bar {
      position: relative;
    }

    .guided-v2-popular-queries {
      padding: 0 1em;
    }
  }

  .guided-v2-section__footer {
    padding: 8px 16px 16px;
  }

  uiaas-guided-v2-chips-carousel,
  .guided-v2-subcomponent-suggestions-bar {
    max-width: 100%;
  }

  .guided-v2-carousel-header,
  .guided-v2-products-header {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    color: #000000;
  }

  .guided-v2-no-links-message__message {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1em 2em;
    .regular-text {
      display: inline;
      padding: 0;
      color: var(--qds-theme-text-subdued, #626469);
    }
    a {
      display: inline;
      text-decoration: underline;
      margin: 0 4px;
      color: $svs-dark-sky-blue;
    }
    .guided-v2-no-links-message__highlight {
      font-weight: bold;
    }
  }
  .guided-v2-no-links-message__icon_centered {
    font-size: 40px;
    display: flex;
    margin-top: 8px;
    margin-bottom: 16px;
    justify-content: center;
    color: var(--qds-theme-popup-overlay-background, rgba(0, 0, 0, 0.25));
  }

  .guided-v2-no-results-message__icon_centered {
    font-size: 28px;
    display: flex;
    margin-top: 8px;
    margin-bottom: 16px;
    justify-content: center;
    color: var(--qds-theme-popup-overlay-background, rgba(0, 0, 0, 0.25));
  }
}
.guided-v2-view-all-results {
  margin-top: 20px;
}

.guided-v2-history-of-searches {
  &__label {
    color: #626469;
    font-size: 14px;
    font-weight: 700;
    padding: 12px;
    margin-top: 8px;
    margin-left: 5px;
  }

  &__items {
    --qds-list-item-standard-padding-indent-step: 0;
    padding-inline-start: 0;
    list-style-type: none;
    margin-bottom: 0;
    margin-top: 0;
    max-width: 920px;
  }

  &__item {
    padding: 8px 12px;
    clear: both;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid transparent;
    text-decoration: none;
    cursor: pointer;
  }
  &__item:hover {
    @media (hover) {
      background-color: var(--qds-theme-interactive-background-hover, #e6e6e6);
    }
  }

  &__item--highlighted {
  }

  &__item__text {
    font: var(--qds-control-standard-text);
    margin-right: 15px;
    display: -webkit-box;
    //line-clamp: 2;
    line-height: 25px;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    white-space: normal;
  }

  &__item__text:hover {
    @media (hover) {
      text-decoration: underline;
    }
  }
  &__item__delete {
    margin-left: auto;
    margin-right: 4px;
    padding-top: 1px;
    display: flex;
    align-items: center;
  }
}

ul {
  list-style-type: none;
  padding-inline-start: 0;
  margin-bottom: 0;
  margin-top: 0;
}
.guided-v2-history-of-searches__quartz-icon-wrapper {
  margin-right: 4px;
  padding-top: 1px;
  display: flex;
  align-items: center;
  svg {
    width: 20px;
    height: 20px;
  }
}

uiaas-guided-search-v2.add-selector-strength
  .guided-v2-section__content:last-child:has(.guided-v2-section__footer) {
  padding-bottom: 0;
}
uiaas-guided-search-v2.add-selector-strength
  .guided-v2-section__content:first-child:has(.guided-v2-section__footer) {
  padding-top: 0;
}

.guided-v2-subcomponent-selected-suggestions {
  .guided-v2-carousel-header {
    margin-top: 24px;
  }

  .guided-v2-products-header {
    padding: 0 16px 12px 16px;
  }

  &-content {
    display: flex;
    flex-direction: column;

    a {
      text-decoration: none;
    }
  }

  &-block {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 8px 16px 16px 16px !important;

    &:hover {
      background-color: #e6e9eb;
      p.guided-v2-subcomponent-selected-suggestions-title {
        text-decoration: underline;
      }
    }
  }

  &-icon {
    img {
      width: 80px;
      border-radius: 16px;
    }
  }

  &-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #000000;
    margin-bottom: 8px;
  }

  &-description {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0%;
    color: #626469;
    -webkit-line-clamp: unset;
    max-height: unset;
    display: block;
    overflow: visible;
    text-overflow: unset;

    @media screen and (max-width: 720px) {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      max-height: 3em;
      font-size: 1em;
      line-height: 1.5em;
    }
  }
}

.guided-v2-promoted-divider {
  margin: 0 16px 16px 16px;
  padding-top: 24px;
}
